import clsx from "clsx";
import Styles from "./index.module.scss";
import { ModalInput } from "../../Atoms/InputModal";
import { SelectModal } from "../../Atoms/SelectModal";
import { ADD_KNB_PAYMENT_TYPES } from "../../../Constants/user";
import { useAddKNBForm } from "../../../Hooks/useAddKNBForm";
import { Controller } from "react-hook-form";
import { Button } from "react-bootstrap";

export const InputKnbForm = ({
  label,
  error,
  defaultValue = 0,
  onChange,
  value = 0,
}) => {
  return (
    <div className={clsx(Styles.inputKnb)}>
      <ModalInput
        label={`${label} hiện tại`}
        value={defaultValue}
        isReadOnly={true}
      />
      <span className={clsx(Styles.operator)}> + </span>
      <ModalInput
        label={`${label} thêm`}
        value={value}
        onChange={onChange}
        error={error}
      />
      <span className={clsx(Styles.operator)}> = </span>
      <ModalInput
        label={`${label} thêm`}
        value={isNaN(value) ? 0 : Number(value) + Number(defaultValue)}
        isReadOnly={true}
      />
    </div>
  );
};

export default function AddKNBForm({ user, handleCloseKnbModal }) {
  const { data, control, handleSubmit } = useAddKNBForm({
    user,
    handleCloseKnbModal,
  });
  return (
    <div className={clsx(Styles.container)}>
      <form onSubmit={handleSubmit} className={clsx(Styles.knbForm)}>
        <Controller
          name="knb"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <InputKnbForm
              label="KNB"
              id="knb"
              value={field.value}
              onChange={field.onChange}
              error={error}
              defaultValue={data.Knb}
            />
          )}
        />
        <Controller
          name="knbKhoa"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <InputKnbForm
              label="KNB Khóa"
              id="knbKhoa"
              value={field.value}
              onChange={field.onChange}
              error={error}
              defaultValue={data.KnbKhoa}
            />
          )}
        />
        <Controller
          name="type"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <SelectModal
              label="Loại"
              id="type"
              onChange={field.onChange}
              error={error}
              options={ADD_KNB_PAYMENT_TYPES}
              value={field.value}
            />
          )}
        />
        <div className={clsx(Styles.knbAction)}>
          <Button
            variant="success"
            className={clsx(Styles.button)}
            type="submit"
          >
            Cập nhật
          </Button>
        </div>
      </form>
    </div>
  );
}
